export const ICoreEventsServiceType = Symbol('ICoreEventsService');
